import { useEffect, useRef } from "react";
import { Animated, View } from "react-native";

const CategoryChipSkeleton = () => {
  const opacity = useRef(new Animated.Value(0.3)).current;
  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 1,
          duration: 800,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.3,
          duration: 800,
          useNativeDriver: true,
        }),
      ]),
    ).start();
  }, []);
  return (
    <Animated.View style={{ opacity }}>
      <View className="h-9 w-24 rounded-full bg-ash-3" />
    </Animated.View>
  );
};
export default CategoryChipSkeleton;
